import React from 'react';

import * as styles from './styles.module.scss';

import { NvButton, NvLoader } from '@simwood/nv-react-components';

import { ApiForwardingRule } from '../../../../shared/types/ForwardingRule';
import ForwardingRuleCard from '../ForwardingRuleCard';

interface Props {
  forwardingRules: ApiForwardingRule[];
  isFetching: boolean;
  toggleForwardingRuleEnabled: (fr: ApiForwardingRule) => void;
  deleteForwardingRule: (fr: ApiForwardingRule) => void;
  onCardClick: (fr: ApiForwardingRule) => void;
  onAddClick: () => void;
}

const ForwardingRulesList: React.FC<Props> = ({
  forwardingRules,
  isFetching,
  onCardClick,
  toggleForwardingRuleEnabled,
  deleteForwardingRule,
  onAddClick,
}): JSX.Element => {
  return (
    <>
      {isFetching && (
        <div className={styles.loadingContainer}>
          <NvLoader loading />
        </div>
      )}
      {!isFetching && (
        <div className={styles.container}>
          {forwardingRules.length === 0 ? (
            'No Active Forwarding Rules'
          ) : (
            <div className={styles.table_scroll_wrapper}>
              <table cellPadding='0' cellSpacing='0'>
                <thead>
                  <tr>
                    <td>{/* Enabled */}</td>
                    <td>During</td>
                    <td>Status</td>
                    <td>Action</td>
                    <td>{/* Icons */}</td>
                    <td>Key</td>
                    <td>
                      {/* Edit */}
                      {/* Delete */}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {forwardingRules.map((fr) => (
                    <ForwardingRuleCard
                      key={fr.id}
                      forwardingRule={fr}
                      onClick={onCardClick}
                      toggleEnabled={toggleForwardingRuleEnabled}
                      remove={deleteForwardingRule}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <NvButton onClick={onAddClick}>Add</NvButton>
        </div>
      )}
    </>
  );
};

export default ForwardingRulesList;
